import axios from 'axios'
import Vue from 'vue'
import Vapi from 'vuex-rest-api'
import { querySerializer } from '@/utils/store'
import { normalizeEvent } from '@/utils/date'

let logsIdsViewed
try {
  logsIdsViewed = JSON.parse(localStorage.getItem('viewed-notifications-school')) || []
} catch (e) {
  logsIdsViewed = []
}

const api = new Vapi({
  axios,
  state: {
    events: [],
    b2b: [],
    logs: [],
    logsIds: [],
    logsIdsViewed,
    eventsFiltered: false,
    metric: {},
  },
})
  .get({
    action: 'getEvents',
    property: 'events',
    path: '/events',
    queryParams: true,
    requestConfig: querySerializer,
    onSuccess(s, { data: events }, axios, { params }) {
      s.b2b = events.filter(item => item.type.id === 3).map(normalizeEvent).sort((a, b) => a.time_start - b.time_start)
      events = events.filter(item => item.type.id !== 3)
      s.eventsFiltered = params.filter && Object.values(params.filter).some((list) => list.length)
      s.events = events.map(normalizeEvent).sort((a, b) => a.time_start - b.time_start)
      //s.actualEvent = s.events[0]
    },
  })
    .get({
      action: 'getEvent',
      property: 'eventResult',
      path: ({ id }) => `/event/${id}`,
      onSuccess(){}
    })
  .get({
    action: 'getActualEvent',
    property: 'actualEvent',
    path: '/event/actual',
    queryParams: true,
    onSuccess(s, { data }) {
      s.actualEvent = data && data[0]
    },
  })
  .get({
    action: 'getLogs',
    property: 'logs',
    path: '/event/logs',
    onSuccess(s, { data }) {
      s.logs = data.map((e) => {
        e.created_at = e.created_at * 1000
        return e
      })
    },
  })
  .get({
    action: 'getLogsIds',
    property: 'logsIds',
    path: '/event/logs/id',
  })
  .get({
    action: 'getMetric',
    property: 'metric',
    path: '/event/metric',
  })
  .post({
    action: 'sendRate',
    property: 'sendRateResult',
    path: ({ id }) => `event/${id}/rate`,
  })
  .post({
    action: 'readLog',
    path: ({ id }) => `/event/logs/${id}/read`,
    onSuccess(s, { data }) {
      if (data?.id) {
        data.created_at = data.created_at * 1000
        s.logs = [...s.logs.map((x) => (x.id !== data.id ? x : data))]
      }
    },
  })
  .getStore({ namespaced: true })

export default {
  ...api,
  mutations: {
    updateEvent(s, event) {
      const index = s.events.findIndex(({ id }) => id === event.id)
      Vue.set(s.events, index, normalizeEvent(event))
    },
    setLogsIdsViewed(s, list) {
      s.logsIdsViewed = list
      localStorage.setItem('viewed-notifications-school', JSON.stringify(list))
    },
    addLogId(s, id) {
      s.logsIds.push(id);
    },
    ...api.mutations,
  },
  getters: {
    notificationNew(s) {
      return s.logsIds.filter((id) => !s.logsIdsViewed.includes(id)).length
    },
  },
}
